export default __webpack_public_path__ + "static/media/img-dropdown-blue.dae72a71.svg";